// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-cta-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.9rem 2.25rem;
  background: var(--interactive);
  color: var(--interactive-fg);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.02em;
  border-radius: var(--radius-pill);
  box-shadow: var(--shadow);
  transition:
    background var(--transition),
    transform var(--transition),
    box-shadow var(--transition);
}

.order-cta-button:hover {
  background: var(--interactive-hover);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.order-cta-button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/OrderCtaButton/OrderCtaButton.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB;;;gCAG8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB","sourcesContent":[".order-cta-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.9rem 2.25rem;\n  background: var(--interactive);\n  color: var(--interactive-fg);\n  font-weight: 700;\n  font-size: 1rem;\n  letter-spacing: 0.02em;\n  border-radius: var(--radius-pill);\n  box-shadow: var(--shadow);\n  transition:\n    background var(--transition),\n    transform var(--transition),\n    box-shadow var(--transition);\n}\n\n.order-cta-button:hover {\n  background: var(--interactive-hover);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.order-cta-button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
